import { useDispatch } from 'react-redux';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import PlanPrice from 'Containers/Plans/components/PlanPrice';
import {
  FRONT_PLANS,
  getPlanToLowerCase,
  getPlanToUpperCase,
  parsePlans,
  PLANS_MODE,
  PLAN_SHORT_NAME_DICTIONARY,
} from 'Constants/plans';
import { PAYMENT_METHOD_MODAL } from 'Constants/modals';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { ResultType } from 'Types/common';
import ButtonPlan from './components/ButtonPlan';
import * as Styled from './styles';
import { UpsellingCardProps } from './types';
import InfoPlan from './components/InfoPlan';
import { getUpsellingRecommendPlan } from './utils';

const UpsellingCard = ({
  upsellingProps,
  successUrl,
  cancelUrl,
  result,
}: UpsellingCardProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const { name, price, description, priceUser } = upsellingProps;
  const dispatch = useDispatch();
  const handleClick = (plan: FRONT_PLANS): void => {
    if (parsePlans(name) !== FRONT_PLANS.FLEX) {
      dispatch(
        showModalAction({
          options: {
            type: PAYMENT_METHOD_MODAL,
            data: {
              plan: parsePlans(plan),
              successUrl,
              cancelUrl,
              upsellingProps,
            },
          },
        })
      );
    }
  };

  const userHaveDiscount = price?.amount !== priceUser?.amount;

  const isRecommended = getUpsellingRecommendPlan(upsellingProps, result as ResultType);
  const parsedPlan = parsePlans(name);
  const isPayLater =
    parsedPlan === FRONT_PLANS.FLEX
      ? getPlanToLowerCase(FRONT_PLANS.FLEX)
      : PLAN_SHORT_NAME_DICTIONARY[parsedPlan];

  return (
    <Styled.Container>
      <Styled.Recommended isRecommended={name === isRecommended}>
        <Text type="paragraphs" color="light" size="XS_L_S" align="center">
          {t(`Upselling.recommended.plan`, {
            context: isPayLater,
          })}
        </Text>
      </Styled.Recommended>
      <FlexContainer align="center" direction="column" justify="center" gap="dimension_16">
        <FlexContainer align="center" mt="fds_size_24">
          <img
            src={`${TAXDOWN_ASSETS_DOMAIN}/plans/smart-filter/v2/${PLANS_MODE[parsedPlan]}_logo.svg`}
            alt={`${name}_logo`}
          />
          <Text type="headline" size="S_L_M" color="dark">
            {getPlanToUpperCase(parsedPlan)}
          </Text>
        </FlexContainer>
        <Styled.Description type="paragraphs" size="L_S_S" color="dark" align="center">
          {description}
        </Styled.Description>
        <Text type="paragraphs" size="M_M_S" color="grey" align="center">
          {t(`PayLater.upselling.info`, {
            context: isPayLater,
          })}
        </Text>
        <PlanPrice
          finalPrice={priceUser.amountDecimal}
          service={PLANS_MODE[parsedPlan]}
          userHaveDiscount={userHaveDiscount}
          realPrice={price.amountDecimal}
        />
        <InfoPlan service={PLANS_MODE[parsedPlan]} />
        <ButtonPlan name={name} onClick={() => handleClick(name)} data={result} />
      </FlexContainer>
    </Styled.Container>
  );
};

export default UpsellingCard;
